import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { environment } from '@env';

export function passwordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const hasUpperCase = /[A-Z]+/.test(value);
        const hasLowerCase = /[a-z]+/.test(value);
        const hasNumeric = /[0-9]+/.test(value);
        const hasSpecial = new RegExp(`[${environment.passwordSpecialCharacters.join('')}]+`).test(value);

        const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecial;

        return !passwordValid
            ? {
                  passwordStrength: {
                      hasUpperCase: hasUpperCase,
                      hasLowerCase: hasLowerCase,
                      hasNumeric: hasNumeric,
                      hasSpecial: hasSpecial,
                  },
              }
            : null;
    };
}
